import { render } from "./PdfCartaPropostaProdutoCard.vue?vue&type=template&id=6bd535de&scoped=true"
import script from "./PdfCartaPropostaProdutoCard.vue?vue&type=script&lang=js"
export * from "./PdfCartaPropostaProdutoCard.vue?vue&type=script&lang=js"

import "./PdfCartaPropostaProdutoCard.vue?vue&type=style&index=0&id=6bd535de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd535de"]])

export default __exports__